import { xhrPatch } from './xhr-patch';
import { RecordsQueue } from './Queue';
import { ObserverApi } from 'observers/types';

/**
 *
 */
export class Xhr implements ObserverApi {
  readonly xhrOld: XMLHttpRequest;

  readonly queue: typeof RecordsQueue;

  /**
   *
   */
  constructor() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.xhrOld = window.XMLHttpRequest;
    this.queue = RecordsQueue;
  }

  /**
   * Start xhr requests sniffing event
   */
  start() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    xhrPatch(window.XMLHttpRequest);
  }

  /**
   * Stop xhr requests sniffing event
   */
  stop() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.XMLHttpRequest = this.xhrOld;
    this.clearRecords();
  }

  /**
   * Get all records
   */
  getRecords() {
    return Array.from(this.queue.getData()).map(([, value]) => value);
  }

  /**
   * Get last record from queue
   */
  getLastRecord(): any {
    const records = this.getRecords();
    return records[records.length - 1];
  }

  /**
   *  Clear records
   */
  clearRecords() {
    this.queue.clear();
  }
}
